import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { getQuestion, patchQuestion, postQuestion } from "../../api/api_question"
import { cleanEntity } from "../../Common/js/clean_entity"
import withHooks from "../../Common/jsx/WithHooks"
import { FR, GB } from "country-flag-icons/react/3x2"
import { ucFirst } from "../../Common/js/generic_functions"
import { ENDPOINT_RESPONSE_TYPES, getResponseTypes } from "../../api/api_response_type"
import { ENDPOINT_QUESTION_TYPES, getQuestionTypes } from "../../api/api_question_type"
import Select from "react-select"
import TableOfEntities from "../../Common/jsx/TableOfEntities"
import { getResponseChoices } from "../../api/api_response_choice"

class QuestionForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      statementFr: "",
      statementEn: "",
      responseType: "",
      questionType: "",
      responseChoices: [],
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = true
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      responseTypes: [],
      questionTypes: [],
      responseChoices: [],
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)
    this.fixPipesAndCopyFr = this.fixPipesAndCopyFr.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
    this.getRelatedEntities()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getQuestion(this.props.entityId)
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity, isReadyToRender: true })
    }
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    Promise.all([getResponseTypes(), getQuestionTypes(), getResponseChoices()]).then((promisesResults) => {
      let [responseTypes, questionTypes, responseChoices] = promisesResults

      this.dMgr.debug("getRelatedEntities done")
      this.setState({
        responseTypes: responseTypes["hydra:member"],
        // responseTypesAsObject: getObjectIdKey(responseTypes["hydra:member"]),
        questionTypes: questionTypes["hydra:member"],
        // questionTypesAsObject: getObjectIdKey(questionTypes["hydra:member"]),
        responseChoices: responseChoices["hydra:member"],
        // responseChoicesAsObject: getObjectIdKey(responseChoices["hydra:member"]),
      })
    })
    // /CONFIG =================================================================================================
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      // statementFr: Yup.string().required(this.props.t("message.required")),
      // statementEn: Yup.string().required(this.props.t("message.required")),
      responseType: Yup.object().test("is-empty", this.props.t("message.required"), (value) => value && Object.keys(value).length > 0),
      questionType: Yup.object().test("is-empty", this.props.t("message.required"), (value) => value && Object.keys(value).length > 0),
    })
    // /CONFIG =================================================================================================
  }

  fixPipesAndCopyFr(entity) {
    entity.statementFr = entity.statementFr.replace(/ /g, "|")
    entity.statementEn = entity.statementFr

    entity.responseChoices = entity.responseChoices.map((responseChoice) => {
      responseChoice.responseEn = responseChoice.responseFr
      responseChoice.justificationFr = responseChoice.justificationFr.replace(/ /g, "|")
      responseChoice.justificationEn = responseChoice.justificationFr
      return responseChoice
    })

    console.log(entity)
    this.setState({ entity: entity })
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)
    let entity = cleanEntity(values)

    entity.responseType = ENDPOINT_RESPONSE_TYPES + "/" + entity.responseType.id
    entity.questionType = ENDPOINT_QUESTION_TYPES + "/" + entity.questionType.id

    // let responseChoices = []
    // entity.responseChoices = Object.keys(entity.responseChoices).map((key) => {
    //   let responseChoice = entity.responseChoices[key]
    //   responseChoice["question"] = ENDPOINT_QUESTIONS + "/" + entity.id
    //   return responseChoice
    //   // return ENDPOINT_RESPONSE_CHOICES + "/" + responseChoice.id
    // })

    // entity.responseChoices = responseChoices

    try {
      // CONFIG ==================================================================================================

      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postQuestion(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchQuestion(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        entitiesType: this.props.entitiesType,
      })
      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container fluid>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              {/* {console.log("Formik values:", values)}
              {console.log("Formik errors:", errors)}
              {console.log("Formik touched:", touched)} */}
              <Row>
                <Col md={12}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={12}>
                            <Row>
                              <Col md={6}>
                                <Row className="margin-top-8">
                                  <Col md={3} className="margin-top-8">
                                    {this.props.t("form.statement")} <FR title="Français" className="lang_flag" /> {this.props.t("app.dbp")}
                                  </Col>
                                  <Col md={9}>
                                    <Form.Group controlId="formStatementFr">
                                      <Field as={Form.Control} name="statementFr" isInvalid={touched.statementFr && errors.statementFr} onChange={handleChange} value={values.statementFr} />

                                      <Form.Control.Feedback type="bgalid">
                                        <ErrorMessage name="statementFr" />
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row className="margin-top-8">
                                  <Col md={3} className="margin-top-8">
                                    {this.props.t("form.statement")} <GB title="English" className="lang_flag" /> {this.props.t("app.dbp")}
                                  </Col>
                                  <Col md={9}>
                                    <Form.Group controlId="formStatementEn">
                                      <Field as={Form.Control} name="statementEn" isInvalid={touched.statementEn && errors.statementEn} onChange={handleChange} value={values.statementEn} />

                                      <Form.Control.Feedback type="bgalid">
                                        <ErrorMessage name="statementEn" />
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className="margin-top-8">
                                  <Col md={3} className="margin-top-8">
                                    <Form.Label>{this.props.t("form.questionType") + this.props.t("app.dbp")}</Form.Label>
                                  </Col>
                                  <Col md={9}>
                                    <Form.Group controlId="formQuestionType">
                                      <Select
                                        id="input_select_question_type"
                                        classNamePrefix="custom-react-select"
                                        // placeholder={this.props.t("form.questionType")}
                                        className={`react-select ${touched.questionType && errors.questionType ? "react-select-invalid" : ""}`}
                                        name="questionType"
                                        options={this.state.questionTypes
                                          .filter((questionType) => {
                                            return questionType.isVisible
                                          })
                                          .sort((a, b) => {
                                            if (a["name" + ucFirst(this.props.i18n.resolvedLanguage)] < b["name" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                              return -1
                                            }
                                            if (a["name" + ucFirst(this.props.i18n.resolvedLanguage)] > b["name" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                              return 1
                                            }
                                            return 0
                                          })
                                          .map((questionType) => {
                                            return {
                                              value: questionType,
                                              label: <>{questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)]}</>,
                                            }
                                          })}
                                        defaultValue={
                                          values.questionType !== undefined
                                            ? {
                                                value: values.questionType,
                                                label: values.questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)],
                                              }
                                            : ""
                                        }
                                        onChange={(e) => {
                                          setFieldValue("questionType", e.value)
                                        }}
                                      />

                                      {touched.questionType && errors.questionType && <div className="invalid-feedback d-block">{errors.questionType}</div>}
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row className="margin-top-8">
                                  <Col md={3} className="margin-top-8">
                                    <Form.Label>{this.props.t("form.responseType") + this.props.t("app.dbp")}</Form.Label>
                                  </Col>
                                  <Col md={9}>
                                    <Form.Group controlId="formResponseType">
                                      <Select
                                        id="input_select_response_type"
                                        classNamePrefix="custom-react-select"
                                        // placeholder={this.props.t("form.responseType")}
                                        className={`react-select ${touched.responseType && errors.responseType ? "react-select-invalid" : ""}`}
                                        name="responseType"
                                        options={this.state.responseTypes
                                          .filter((responseType) => {
                                            return responseType.isVisible
                                          })
                                          .sort((a, b) => {
                                            if (a["name" + ucFirst(this.props.i18n.resolvedLanguage)] < b["name" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                              return -1
                                            }
                                            if (a["name" + ucFirst(this.props.i18n.resolvedLanguage)] > b["name" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                              return 1
                                            }
                                            return 0
                                          })
                                          .map((responseType) => {
                                            return {
                                              value: responseType,
                                              label: <>{responseType["name" + ucFirst(this.props.i18n.resolvedLanguage)]}</>,
                                            }
                                          })}
                                        defaultValue={
                                          values.responseType !== undefined
                                            ? {
                                                value: values.responseType,
                                                label: values.responseType["name" + ucFirst(this.props.i18n.resolvedLanguage)],
                                              }
                                            : ""
                                        }
                                        onChange={(e) => {
                                          setFieldValue("responseType", e.value)
                                        }}
                                      />

                                      {touched.responseType && errors.responseType && <div className="invalid-feedback d-block">{errors.responseType}</div>}
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <br />

                            <Row>
                              <Col className="text-center">
                                <Button
                                  id="btn-fix-pipes-copy-fr"
                                  onClick={() => {
                                    this.fixPipesAndCopyFr(values)
                                  }}
                                  size="sm"
                                  className="margin-right-5 button-color2"
                                >
                                  {this.props.t("app.fixPipesAndCopyFr")}
                                </Button>
                              </Col>
                            </Row>
                            <br />

                            <div className="form-group-border">
                              {this.props.t("form.responseChoices") + this.props.t("app.dbp")}
                              <br />
                              <br />
                              <TableOfEntities
                                tableName="questionResponseChoices"
                                striped={false}
                                hover={false}
                                headers={[
                                  // {
                                  //   name: "id",
                                  //   title: this.props.t("form.id"),
                                  // },
                                  {
                                    name: "responseFr",
                                    title: [this.props.t("form.response"), <FR key="thFR" title="Français" className="lang_flag margin-left-5" />],
                                    className: "width-100",
                                  },
                                  {
                                    name: "justificationFr",
                                    title: [this.props.t("form.justification"), <FR key="thFR" title="Français" className="lang_flag margin-left-5" />],
                                  },
                                  {
                                    name: "responseEn",
                                    title: [this.props.t("form.response"), <GB key="thGB" title="English" className="lang_flag margin-left-5" />],
                                    className: "width-100",
                                  },
                                  {
                                    name: "justificationEn",
                                    title: [this.props.t("form.justification"), <GB key="thGB" title="English" className="lang_flag margin-left-5" />],
                                  },
                                  {
                                    name: "isCorrect",
                                    title: this.props.t("form.isCorrect"),
                                    className: "width-50",
                                  },
                                  {
                                    name: "actions",
                                    title: this.props.t("app.actions"),
                                  },
                                ]}
                                rows={[
                                  ...(values.responseChoices.length > 0
                                    ? values.responseChoices.map((entity, index) => {
                                        this.dMgr.debug("TableOfEntities questionResponseChoices:", entity)

                                        return {
                                          entity: entity,
                                          fields: [
                                            // {
                                            //   name: "questionResponseChoice.id",
                                            //   value: entity.id,
                                            //   // type: "input-text",
                                            //   // value: entity.responseChoices,
                                            // },

                                            {
                                              name: "responseFr",
                                              type: "input-text",
                                              value: entity.responseFr,
                                              tabIndexCount: true,
                                            },
                                            {
                                              name: "justificationFr",
                                              type: "input-text",
                                              value: entity.justificationFr,
                                            },
                                            {
                                              name: "responseEn",
                                              type: "input-text",
                                              value: entity.responseEn,
                                            },
                                            {
                                              name: "justificationEn",
                                              type: "input-text",
                                              value: entity.justificationEn,
                                            },
                                            {
                                              name: "isCorrect",
                                              className: "text-center",
                                              type: "input-checkbox",
                                              value: entity.isCorrect,
                                            },
                                            // {
                                            //   name: "childrenQuantity",
                                            //   type: "input-number",
                                            //   value: entity.childrenQuantity,
                                            //   minValue: 1,
                                            // },
                                            {
                                              name: "actions",
                                              actions: ["deleteInline"],
                                            },
                                          ],
                                        }
                                      })
                                    : []),

                                  ...(touched.responseChoices && errors.responseChoices
                                    ? [
                                        {
                                          entity: {},
                                          fields: [
                                            {
                                              name: "error",
                                              value: (
                                                <div className="invalid-feedback d-block">
                                                  <ErrorMessage name="responseChoices" />
                                                </div>
                                              ),
                                              className: "text-center",
                                              colspan: 4,
                                            },
                                          ],
                                        },
                                      ]
                                    : []),
                                  {
                                    entity: {},
                                    fields: [
                                      {
                                        name: "actions",
                                        actions: ["addXElementsInLine"],
                                        className: "text-center",
                                        label: this.props.t("action.add") + " " + this.props.t("entity.responseChoices"),
                                        colspan: 12,
                                        defaultAddNumber: 5,
                                      },
                                    ],
                                  },
                                ]}
                                entityType="responseChoice"
                                entitiesType="responseChoices"
                                editEntity={this.props.t("entity.childProductCompositions")}
                                handleChange={(inputValue, responseChoice) => {
                                  // console.log("set", inputValue, responseChoice)

                                  if (responseChoice.id !== undefined) {
                                    // childProductComposition EDIT
                                    // console.log("edit", values.responseChoices)

                                    let responseChoices = [...values.responseChoices].map((currentResponseChoice) => {
                                      // console.log(childProductComposition)
                                      if (currentResponseChoice.id === responseChoice.id) {
                                        // console.log("currentResponseChoice", currentResponseChoice, inputValue.target.value)

                                        // return inputValue.target.value
                                        currentResponseChoice[inputValue.target.name] = inputValue.target.value
                                      }

                                      return currentResponseChoice

                                      // console.log("done")
                                    })

                                    // console.log("ok responseChoices", responseChoices)

                                    setFieldValue("responseChoices", responseChoices)
                                  }
                                }}
                                deleteInlineEntity={(entity, index, index2, doneCallback) => {
                                  let responseChoices = [...values.responseChoices].filter((responseChoice) => {
                                    return entity.id !== responseChoice.id
                                  })
                                  setFieldValue("responseChoices", responseChoices)
                                  doneCallback()
                                }}
                                addInLineEntity={(addXElementsInLineNumber) => {
                                  let responseChoices = [...values.responseChoices]
                                  let nextKey
                                  for (let i = 0; i < addXElementsInLineNumber; i++) {
                                    nextKey =
                                      responseChoices.length === 0
                                        ? 0
                                        : [...responseChoices].sort((a, b) => {
                                            if (a.id < b.id) {
                                              return 1
                                            }
                                            if (a.id > b.id) {
                                              return -1
                                            }
                                            return 0
                                          })[0].id + 1

                                    responseChoices.push({ id: nextKey, entityType: "responseChoice", responseFr: "", responseEn: "", justificationFr: "", justificationEn: "", isCorrect: false })
                                  }

                                  setFieldValue("responseChoices", responseChoices)
                                }}
                              />
                            </div>
                          </Col>
                        </Row>

                        <br />
                        <Row>
                          <Col md={5}></Col>
                          <Col md={1} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={1} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(QuestionForm)
